// span with cart type
const cartTypeElement = document.querySelector('span[data-cartType]');
if (!cartTypeElement) {
  console.error('Cart type element not found.');
} else {
  const cartType = cartTypeElement.getAttribute('data-cartType');
  class BaseCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) {
        console.error('Cart icon bubble not found.');
        return;
      }
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.classList.contains('active')) {
          this.open(cartLink);
        } else {
          this.close();
        }
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      setTimeout(() => {
        if (cartType === 'drawer') {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        }
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  if (cartType === 'drawer') {
    class CartDrawer extends BaseCartDrawer {
      constructor() {
        super();
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer',
            selector: '#CartDrawer',
          },
          {
            id: 'cart-icon-bubble',
          },
        ];
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  } else if (cartType === 'minicart') {
    class CartDrawer extends BaseCartDrawer {
      constructor() {
        super();
        document.addEventListener('scroll', this.close.bind(this));
        document.addEventListener('click', this.onOutsideClick.bind(this));
        this.hideTimeout = null;
      }

      connectedCallback() {
        if (window.innerWidth > 749) {
          this.addEventListener('mouseover', this.resetHideTimeout);
        }
        this.addEventListener('mouseleave', this.startHideTimeout);
      }

      resetHideTimeout() {
        clearTimeout(this.hideTimeout);
      }

      startHideTimeout() {
        this.hideTimeout = setTimeout(() => {
          this.close();
        }, 4000);
      }

      onOutsideClick(e) {
        if (!this.contains(e.target) && this.classList.contains('active')) {
          this.close();
        }
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });
        this.startHideTimeout();
      }

      close() {
        this.classList.remove('active');
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer',
            selector: '#CartDrawer',
          },
          {
            id: document.querySelector('[id$=header]').id.split('shopify-section-')[1],
            selector: '#cart-icon-bubble',
          },
        ];
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
